import React from 'react';

function SelectTopic({ topics, selectedTopic, onChange }) {
  return (
    <select className="study-select" value={selectedTopic} onChange={onChange}>
      <option value="">— Choose —</option>
      {topics.map((topic) => (
        <option key={topic.id} value={topic.id}>
          {topic.vendor && topic.examnumber
            ? `${topic.vendor} - ${topic.name} - ${topic.examnumber}`
            : topic.vendor
            ? `${topic.vendor} - ${topic.name}`
            : topic.name}
        </option>
      ))}
    </select>
  );
}

export default SelectTopic;
